import { SearchResult } from '@/modules/articles/model/search-result';
import { Article, ArticleUtil } from '@/modules/articles/model/article';
import { KeywordBadge } from '@/shared/badges/export';
import { AgedDateFormat, DateFormat } from '@/core/date/export';
import styles from '@/shared/components/link-styles.module.scss';
import { useState } from 'react';
import ArticleModal from '@/modules/articles/components/articles/article-modal';
import GenreBadge from '@/modules/articles/components/genre-badge';

interface Props {
  articles?: SearchResult<Article>[];
  onArticleClick: Function;
  colorizeDates?: boolean;
  showGenreTags?: boolean;
  hideAuthor?: boolean;
  showKeywords?: boolean;
}

export default function SearchResultList({ articles, colorizeDates = true }: Props) {
  const [selected, setSelected] = useState<Article>();

  return (
    <div className={'h-100 container-fluid'}>
      {articles?.map((value, index) => {
        let scale = 0.5;
        let hideAuthor = false;

        if (ArticleUtil.hasGenre(value.item, 'HEADLINE')) {
          scale = 5;
          hideAuthor = true;
        }
        if (ArticleUtil.hasGenre(value.item, 'BULLET')) {
          scale = 2;
          // eslint-disable-next-line
          hideAuthor = true;
        }

        const type = value.item.genre.find(value1 => value1.scheme === 'mnitype');

        return (
          <div
            key={'article-' + value.item.uri}
            className={`row mb-2 border-bottom`}
            onClick={event => setSelected(value.item)}
          >
            <div className={'col-3 align-top  text-muted '}>
              {colorizeDates ? (
                <AgedDateFormat
                  format={'MMM D, h:mma YYYY'}
                  date={value.item.firstcreated}
                  scale={scale}
                />
              ) : (
                <DateFormat format={'MMM D, h:mma YYYY'} date={value.item.firstcreated} />
              )}
            </div>

            <div className={`col align-top text-text-dark mb-1 ${styles.clickable}`}>
              <span className={'fw-bold'}> {value.item.headline}</span>
              <div className={' small text-muted font-monospace'}>
                {type && <GenreBadge genre={type} />}{' '}
                {value.score ? 'search score: ' + value.score?.toFixed(3) : ''}
              </div>

              {
                <div>
                  {value.item.keywords.map(s => (
                    <span className={'small'}>
                      <KeywordBadge keyword={s} />{' '}
                    </span>
                  ))}
                </div>
              }
            </div>
          </div>
        );
      })}

      <ArticleModal onClose={() => setSelected(undefined)} articleId={selected?.uri} />
    </div>
  );
}
